/** Customer-facing copy for invite-first member join flows (P0-C). */

export const JOIN_MEMBER_HEADLINE = 'Join a league for free';

export const JOIN_MEMBER_DETAIL =
  'Enter an invite code or link from your commissioner. League creation is not required to join as a member.';

export const JOIN_INVITE_CODE_LABEL = 'Invite code or link';

export const JOIN_INVITE_CODE_PLACEHOLDER = 'sc_inv_… or https://scoutlytics.gg/lsc/join/…';

export const JOIN_INVITE_CODE_SUBMIT = 'Continue with invite';

export const JOIN_INVITE_CODE_INVALID_INPUT = 'Enter a valid invite code or link.';

export const JOIN_INVITE_LINK_HEADLINE = 'League invite';

export const JOIN_INVITE_LINK_DETAIL =
  'Sign in with Twitch to preview and accept this commissioner invite. Joining is free for members.';

export const JOIN_INVITE_SIGN_IN_TITLE = 'Sign in to join this league';

export const JOIN_INVITE_SIGN_IN_DETAIL =
  'Your invite link is saved. After sign-in you can preview the league and join immediately.';

export const JOIN_INVITE_PREVIEW_INTRO = 'You are invited to';

export const JOIN_INVITE_ACCEPT_DETAIL =
  'Accept this invite to join immediately. No commissioner subscription is required for members.';

export const JOIN_INVITE_JOIN_BUTTON = 'Join league';

export const JOIN_INVITE_JOINING = 'Joining…';

export const JOIN_INVITE_SUCCESS_HEADLINE = 'You joined the league';

export const JOIN_INVITE_SUCCESS_DETAIL =
  'Open your league home to watch live games, replays, and upcoming matchups.';

export const JOIN_INVITE_GO_TO_LEAGUE = 'Go to league';

export const JOIN_INVITE_ALREADY_MEMBER_HEADLINE = 'You are already a member';

export const JOIN_INVITE_ALREADY_MEMBER_DETAIL =
  'This invite matches a league you already belong to. Open your league home to continue.';

export const JOIN_BAD_INVITE_HEADLINE = 'Invite unavailable';

export const JOIN_BAD_INVITE_ASK_COMMISSIONER =
  'Ask your commissioner for a new invite link or code.';

export const JOIN_TRY_ANOTHER_CODE = 'Try another code';

export const JOIN_GO_TO_LEAGUES = 'Go to my leagues';

export const JOIN_COMMISSIONER_SECONDARY_LABEL = 'Start a league as commissioner';

export const JOIN_COMMISSIONER_SECONDARY_NOTE =
  'Requires an active commissioner subscription.';

export const JOIN_MY_REQUESTS_HEADLINE = 'My join requests';

export const JOIN_MY_REQUESTS_DETAIL =
  'Commissioner invite links join immediately. This section tracks separate access requests when a league uses approval-based joining.';

export const JOIN_MY_REQUESTS_EMPTY =
  'You do not have any pending access requests. Use an invite code to join a league immediately.';

export function shortenInviteCodeForDisplay(code: string): string {
  const trimmed = code.trim();
  if (trimmed.length <= 16) return trimmed;
  return `${trimmed.slice(0, 10)}…${trimmed.slice(-4)}`;
}
